export default __webpack_public_path__ + "static/media/puzzle1.00d8d306.svg";